 
 
 
 
 
 
/**
 * Utility class for creating map markers.
 *
 * @class SVGIcon
 * @namespace L
 * @extends L.Icon
 * @module Map
 * @constructor
 * @param {Object} [options]
 * @param {Object} [options.background]
 * @param {Number[]} [options.background.iconSize=[30, 36]]
 * @param {Number[]} [options.background.iconAnchor=[15, 36]]
 * @param {String} [options.background.icon="icon-marker-black"]
 * @param {Boolean} [options.background.noPlainSVG=false]
 * @param {Object} [options.icon]
 * @param {Number[]} [options.icon.iconSize=[30, 30]]
 * @param {Number[]} [options.icon.iconAnchor=[0, 0]]
 * @param {String} [options.icon.icon="icon-flag-white"]
 * @param {Boolean} [options.icon.noPlainSVG=false]
 * @param {Number[]} [options.popupAnchor=[0, -30]]
 * @param {Number} [options.opacity=0.8]
 */
define(['leaflet', 'services/utils'], function(L, Utils) {
    'use strict';

    var defaultOptions;

    function setNodeIconAnchorStyle(options, node) {
        var anchor;
        if (options.iconAnchor) {
            anchor = L.point(options.iconAnchor);
            node.style.marginLeft = -anchor.x + 'px';
            node.style.marginTop = -anchor.y + 'px';
        }
    }

    function setNodeStyleFromStyleOption(options, node) {
        var css;
        for (css in options.style) {
            if (options.style.hasOwnProperty(css)) {
                node.style[css] = options.style[css];
            }
        }
    }
    // TODO: A CSS class name should be used to apply this CSS rules instead of doing it programmatically
    function setNodeStyle(node, options) {
        node.style.width = options.iconSize[0] + 'px';
        node.style.height = options.iconSize[1] + 'px';
        node.style.backgroundSize = options.iconSize[0] + 'px ' + options.iconSize[1] + 'px';
        setNodeIconAnchorStyle(options, node);
        node.style.position = 'absolute';
        node.style.textAlign = 'center';
        node.style.verticalAlign = 'middle';
        node.style.lineHeight = options.iconSize[1] + 'px';
        if (options.style) {
            setNodeStyleFromStyleOption(options, node);
        }
    }

    function extractBackgroundToPlainSVG(node, options) {
        var clonedNode, match, svg;
        clonedNode = node.cloneNode();
        clonedNode.style.display = 'none';
        document.body.appendChild(clonedNode);
        svg = window.getComputedStyle(clonedNode).getPropertyValue('background-image');
        document.body.removeChild(clonedNode);

        if (!svg) {
            return;
        }
        match = svg.match(/(%3Csvg[^"']+%3C%2Fsvg%3E)/i);
        if (!match) {
            return;
        }
        svg = decodeURIComponent(match[1]);
        node.innerHTML = svg;
        node.firstChild.setAttribute('width', options.iconSize[0] + 'px');
        node.firstChild.setAttribute('height', options.iconSize[1] + 'px');
        node.firstChild.setAttribute('style', 'display: block; position: absolute;');
        node.style.backgroundImage = 'none';
    }

    /**
     * @ignore
     * Receive class names as arguments and returns a string with the valid ones.
     * @param   {String[]} classNames  Following jsdoc spec: http://usejsdoc.org/tags-param.html
     * @return  {String}                String with class names
     */
    function concatClassNames(classNames) { 

    L.SVGIcon = L.Icon.extend({
        initialize: function(options) {
            this.options = L.Util.extend({}, defaultOptions, options);
            if (!options) {
                return;
            }
            mergeOptions(this.options, options, 'background');
            mergeOptions(this.options, options, 'icon');
        },

        createIcon: function() {
            var options = this.options;
            this.container = createNode(options.background || options.icon, null, 'icon-marker');
            if (options.background && options.icon && options.icon.icon) {
                createNode(options.icon, this.container, null);
            }
            if (options.content) {
                this.contentContainer = createDiv(options.content, this.container, null);
            }
            L.DomUtil.setOpacity(this.container, options.opacity);
            return this.container;
        },

        /**
         * Sets the HTML content of the marker.
         * @method setContent
         * @param {String} content Valid HTML string
         */
        setContent: function(content) {
            if (this.contentContainer) {
                this.contentContainer.innerHTML = content;
            }
        },

        /**
         * Changes the opacity of the marker.
         * @method setOpacity
         * @param {Number} opacity Number between 0 and 1
         */
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            L.DomUtil.setOpacity(this.container, opacity);
        }
    });

    L.svgIcon = function(options) {
        return new L.SVGIcon(options);
    };

    return L.SVGIcon;
});



// WEBPACK FOOTER //
// ./display/svgIcon.js